import { match, P } from "ts-pattern";
class SwatchTarget {
  static Type = "swatch";
  get type() {
    return SwatchTarget.Type;
  }
  introspect(data) {
    return match(data).with({ swatchId: P.string }, ({ swatchId }) => [swatchId]).otherwise(() => []);
  }
}
class FileTarget {
  static Type = "file";
  get type() {
    return FileTarget.Type;
  }
  introspect(_data) {
    return [];
  }
}
class TypographyTarget {
  static Type = "typography";
  get type() {
    return TypographyTarget.Type;
  }
  introspect(_data) {
    return [];
  }
}
class TableTarget {
  static Type = "table";
  get type() {
    return TableTarget.Type;
  }
  introspect(_data) {
    return [];
  }
}
class PageTarget {
  static Type = "page";
  get type() {
    return PageTarget.Type;
  }
  introspect(_data) {
    return [];
  }
}
class ChildrenElementTarget {
  static Type = "children-element";
  get type() {
    return ChildrenElementTarget.Type;
  }
  introspect(_data) {
    return [];
  }
}
const Targets = {
  Swatch: new SwatchTarget(),
  File: new FileTarget(),
  Typography: new TypographyTarget(),
  Table: new TableTarget(),
  Page: new PageTarget(),
  ChildrenElement: new ChildrenElementTarget()
};
export {
  Targets
};
//# sourceMappingURL=introspection.js.map